import { DefaultState, TableDataResponse } from 'features/types';
import { Paging, SelectItem, Tab } from 'api/types';
import { JobSeekerOtherProfileLinks } from 'features/job-seeker-profile';

export interface CommunityAdminJobSeekersFiltersData { }

export type CommunityAdminJobSeekersTableFilters = {
  text?: string;
  tab: string;
  location: google.maps.LatLngLiteral | null;
  fullAddress?: string;
  radius?: string | number;
  assignedPrograms?: SelectItem[];
};

export type CommunityAdminJobSeekersTableRequestFiltersData = {
  text?: string;
  tab: string;
  location: google.maps.LatLngLiteral | null;
  fullAddress?: string;
  radius?: string | number;
  assignedPrograms?: string[];
};

export type CommunityAdminJobSeekersTableRequestData = {
  paging: Paging;
  filters: CommunityAdminJobSeekersTableRequestFiltersData;
  onBehalfOfOrganizationId?: string;
};

export type CommunityAdminJobSeekersState = DefaultState & {
  currentFilters: CommunityAdminJobSeekersTableFilters;
  requestData: CommunityAdminJobSeekersTableRequestData;
  data: {
    tableDataIsLoading: boolean;
    tabsIsLoading: boolean;
    tableData: TableDataResponse<JobSeekerTableView>;
    tabs: Tab[];
    filters: CommunityAdminJobSeekersFiltersData | null;
  },

};

export type CommunityAdminJobSeekersEnhancedFiltersForm = {
  location: google.maps.LatLngLiteral | null;
  fullAddress?: string;
  radius?: string | number;
  assignedPrograms?: SelectItem[];
}

export type GetCommunityAdminJobSeekersTabsFilters = CommunityAdminJobSeekersEnhancedFiltersForm & {
  text?: string;
};

export type JobSeekerTableView = {
  id: string;
  name: string;
  nickName?: string;
  profileHeadline?: string;
  photo?: string;
  phone?: string | null;
  email: string;
  city?: string;
  state?: string;
  zipcode?: number;
  employmentStatus: string[];
  skills?: string[];
  experienceLevels?: string[];
  isVerified: boolean;
  lastLoginAt?: Date;
  programs: string[];
  isCommunityAdmin: boolean;
  leadPrograms: string[];
  managingOnBehalfOf?: string;
  otherProfileLinks?: JobSeekerOtherProfileLinks;
  profileIsPrivate?: boolean;
  profileIsPublicEmploymentStatuse?: boolean;
  profileIsPublicZipCode?: boolean;
  profileIsPublicEmailAddress?: boolean;
  profileIsPublicPhone?: boolean;
  profileIsPublicOneClickResume?: boolean;
  signUpCompleted: boolean;
  managerUsersNames?: string;
  joiningSource?: string;
  joiningSourceLink: string;
  addedByUserName?: string;
  invitedByName?: string;
};

export enum CommunityAdminJobSeekersTabs {
  All = 'All',
  Verified = 'Verified',
  NotVerified = 'NotVerified',
  FullAdmin = 'FullAdmin',
  ViewOnlyAdmin = 'ViewOnlyAdmin',
}

export enum FilterTypes {
  Organization = 'Organization',
  JobSeeker = 'JobSeeker',
}
